class MiniCartUpsells extends HTMLElement {
  static get observedAttributes() {
    return ["products"];
  }

  constructor() {
    super();

    this.loadingClass = "mini-cart__upsells-wrapper--loading";
    this.recommendationsUrl = this.getAttribute("recommendations-url");
    this.recommendationsContainer = this.querySelector(
      "[data-recommendations-container]"
    );
    this.content = this.querySelector(".mini-cart__upsells");
    this.firstLoad = true;

    this._initSwiper();
    this._update();
  }

  attributeChangedCallback(name) {
    if (name === "products") {
      this._update();
    }
  }

  _initSwiper() {
    return window.loadSwiper.then(({ Swiper, Mousewheel }) => {
      const swiperParams = {
        modules: [Mousewheel],
        slidesPerView: "auto",
        speed: 400,
        spaceBetween: 8,
        centerInsufficientSlides: true,
        mousewheel: {
          forceToAxis: true,
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }

  _update() {
    if (!this.hasAttribute("products")) return;

    const sourceProducts = JSON.parse(this.getAttribute("products"));
    this.content.classList.add(this.loadingClass);
    Promise.all(sourceProducts.map((id) => this._getRecommendations(id)))
      .then((recommendations) => {
        const toAppend = recommendations
          .flat()
          .filter(
            (value, index, arr) =>
              index ===
              arr.findIndex(
                (el) =>
                  el.dataset.productRecommendation ===
                  value.dataset.productRecommendation
              )
          )
          .sort((a, b) => a.dataset.sortOrder - b.dataset.sortOrder)
          .slice(0, 8);
        this.style.display = toAppend.length ? null : "none";

        this.recommendationsContainer.innerHTML = "";
        this.recommendationsContainer.append(...toAppend);
        return this._initSwiper();
      })
      .then(() => {
        this.swiper.update();
        this.content.classList.remove(this.loadingClass);
      });
  }

  _getRecommendations(productId) {
    return fetch(
      `${this.recommendationsUrl}?product_id=${productId}&section_id=mini-cart&intent=complementary`
    )
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        return [...doc.querySelectorAll("[data-product-recommendation]")];
      });
  }
}

if (!customElements.get("mini-cart-upsells")) {
  customElements.define("mini-cart-upsells", MiniCartUpsells);
}
